<template>
  <div class="content">
    <div class="newAlliance">
      <div class="d-flex-s" style="height: 50px; padding: 0 10px">
        <div class="d-flex">
          <van-icon @click="goLeft()" name="arrow-left" size="20" />
          <span class="f-t-16 m-l-5">{{ $lang.common_txt328 }}</span>
        </div>
        <div
          class="d-flex m-l-20"
          style="
            background: rgba(0, 0, 0, 0.6);
            padding: 3px 10px 3px 5px;
            border-radius: 20px;
          "
        >
          <img src="../../../assets/img/otgame/amount.png" width="15" />
          <span class="m-l-5" style="min-width: 50px; padding: 2px 0">{{
            InitDate._balUsable
          }}</span>
        </div>
        <p style="width: 30%"></p>
      </div>
      <div style="padding: 10px">
        <div v-if="inviteReadError" class="alliance-diagnostic">
          {{ inviteReadError }}
        </div>
        <div v-if="teamReadError" class="alliance-diagnostic">
          {{ teamReadError }}
        </div>
        <div v-if="vipReadError" class="alliance-diagnostic">
          {{ vipReadError }}
        </div>
        <div class="newAlliance_information">
          <p class="t-c f-t-15 f-w" style="padding-top: 7px">
            {{ $lang.common_txt329 }}
          </p>
          <div class="d-flex-s m-t-20 t-c" style="flex-flow: wrap row">
            <div style="width: 50%">
              <p>{{ $lang.common_txt330 }}</p>
              <p class="m-t-5 f-t-16 f-w" style="color: #ffdc4f">
                {{ InitDate2.totalUserCount }}
              </p>
            </div>
            <div style="width: 50%">
              <p>{{ $lang.common_txt331 }}</p>
              <p class="m-t-5 f-t-16 f-w" style="color: #ffdc4f">
                {{ InitDate2.totalRechargeAmount }}
              </p>
            </div>
            <div class="m-t-15" style="width: 50%">
              <p>{{ $lang.common_txt332 }}</p>
              <p class="m-t-5 f-t-16 f-w" style="color: #ffdc4f">
                {{ InitDate2.newRechargeAmount }}
              </p>
            </div>
            <div class="m-t-15" style="width: 50%">
              <p>{{ $lang.common_txt333 }}</p>
              <p class="m-t-5 f-t-16 f-w" style="color: #ffdc4f">
                {{ InitDate2.newRechargeCount }}
              </p>
            </div>
          </div>
          <div class="card_content" style="margin-top: 25px">
            <div
              class="newAlliance_card d-flex"
              style="align-items: flex-start"
            >
              <div style="width: 40%; text-align: center; padding-top: 12px">
                <img :src="getImgCon()" width="57" />
                <p class="newAlliance_card_txt" style="margin-top: -8px">
                  VIP{{ currentVipLevel }}
                </p>
                <p style="color: rgba(0, 0, 0, 0.65)">
                  {{ $lang.common_txt352 }}
                </p>
                <p class="newAlliance_card_txt2">{{ commissionRateText }}</p>
                <p style="color: rgba(0, 0, 0, 0.65)">
                  {{ $lang.common_txt353 }}
                </p>
                <p class="newAlliance_card_txt2">{{ rebateRateText }}</p>
              </div>
              <div style="width: 60%; text-align: center; padding-top: 20px">
                <p
                  style="
                    color: #122c04;
                    text-decoration: underline;
                    font-style: italic;
                    font-size: var(--vk-fs-base);
                    font-weight: 800;
                  "
                >
                  {{ $lang.common_txt354 }}
                </p>
                <p class="m-t-5" style="color: rgba(0, 0, 0, 0.65)">
                  {{ $lang.common_txt355 }}
                </p>
                <p class="card_right_amount">{{ formatMetric(InitDate2.betEffc) }}</p>

                <div class="card_right_btn t-c">
                  {{ $lang.common_txt356 }}
                </div>
              </div>
            </div>
            <div
              v-if="!isExpanded"
              class="card_desc d-flex f-t-14"
              style="justify-content: center"
              @click="isExpanded = true"
            >
              <span>{{ $lang.common_txt334 }}</span>
              <van-icon
                :name="isExpanded ? 'arrow-up' : 'arrow-down'"
                class="m-l-5"
              />
            </div>
            <div
              v-if="isExpanded"
              class="expanded-content"
              style="height: 200px; overflow: auto"
            >
              <!-- 替换表格为div+p标签结构 -->
              <div class="commission-container">
                <!-- 表头 -->
                <div
                  class="commission-header"
                  style="position: sticky; top: 0; background: #2a5e1c"
                >
                  <p class="commission-col">{{ $lang.common_txt335 }}</p>
                  <p class="commission-col">{{ $lang.common_txt336 }}</p>
                  <p class="commission-col">{{ $lang.common_txt337 }}</p>
                </div>
                <!-- VIP列表 -->
                <div
                  v-for="(item, index) in vipList"
                  :key="index"
                  class="commission-row d-flex"
                  style="border-radius: 10px"
                  :class="[
                    index % 2 === 1 ? 'odd-row' : '',
                    vipLevel === item.vipLevel ? 'current-vip' : ''
                  ]"
                >
                  <p class="commission-col" style="text-align: left">
                    <img
                      style="margin-top: 5px; margin-left: 15px"
                      :src="require(`@/assets/img/vip/V${item.vipLevel}.png`)"
                      height="22"
                    />
                  </p>
                  <p class="commission-col" style="color: #cdff35">
                    {{ item.monthlyBonus }}
                  </p>
                  <p class="commission-col" style="color: #cdff35">
                    {{ item.rechargeAmount }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="card_desc d-flex f-t-14"
              style="justify-content: center"
              v-if="isExpanded"
              @click="isExpanded = false"
            >
              {{ $lang.common_txt334 }}
              <van-icon name="arrow-up" class="m-l-5" />
            </div>
          </div>
          <div class="newAlliance_share">
            <p class="t-c f-t-16 f-w" style="padding-top: 5px">
              {{ $lang.common_txt338 }}
            </p>
            <div style="margin: 27px 0px 0px 16px">
              <img
                v-for="(item, index) in [
                  require('@/assets/img/otgame/pinduoduo_21.png'),
                  require('@/assets/img/otgame/pinduoduo_25.png'),
                  require('@/assets/img/otgame/pinduoduo_26.png'),
                  require('@/assets/img/otgame/pinduoduo_24.png'),
                  require('@/assets/img/otgame/pinduoduo_35.png'),
                  require('@/assets/img/otgame/pinduoduo_23.png')
                ]"
                :key="index"
                :src="item"
                :class="{ 'share-target-disabled': !isInviteShareReady }"
                width="35"
                style="margin-right: 10px"
              />
            </div>
            <p style="text-decoration: underline; margin: 10px 0 0 20px">
              {{ $lang.common_txt339 }}
            </p>
            <div class="d-flex" style="padding: 7px 20px">
              <div
                style="
                  background: #d1d6d4;
                  border-radius: 8px;
                  padding: 10px;
                  color: #000000;
                  width: 73%;
                "
              >
                {{ inviteCode }}
              </div>
              <div
                class="m-l-10 f-t-16 f-w d-flex"
                :class="{ 'copy-btn-disabled': !isInviteShareReady }"
                @click="copyText"
                style="
                  background: linear-gradient(90deg, #fa3f2d, #ff8228);
                  height: 34px;
                  padding: 0 20px;
                  border-radius: 8px;
                "
              >
                {{ $lang.common_txt340 }}
              </div>
            </div>
          </div>
          <div class="newAlliance_display" style="position: relative">
            <p class="t-c f-t-16 f-w" style="padding-top: 8px">
              {{ $lang.common_txt341 }}
            </p>
            <div class="t-c" style="position: absolute; right: 50px; top: 50px">
              <p style="color: #ff5129; font-size: var(--vk-fs-xs)">
                {{ $lang.common_txt342 }}
              </p>
              <p class="f-w">LV {{ allianceDisplay.vipLevel }}</p>
              <p style="color: #ff5129; font-size: var(--vk-fs-xs); margin-top: 5px">
                {{ $lang.common_txt343 }}
              </p>
              <p class="f-w">{{ formatMetric(InitDate2.totalRechargeCount) }}</p>
              <p style="color: #ff5129; font-size: var(--vk-fs-xs); margin-top: 5px">
                {{ $lang.common_txt344 }}
              </p>
              <p class="f-w">{{ formatMetric(InitDate2.betEffcCount) }}</p>
            </div>
            <div
              class="t-c"
              style="position: absolute; right: 10px; top: 180px"
            >
              <p style="color: #ffa800; font-size: var(--vk-fs-xs)">
                {{ $lang.common_txt345 }}
              </p>
              <p class="f-w">{{ commissionRateText }}</p>
              <p style="color: #ffa800; font-size: var(--vk-fs-xs); margin-top: 5px">
                {{ $lang.common_txt346 }}
              </p>
              <p class="f-w">{{ formatMetric(InitDate2.totalRechargeAmount) }}</p>
              <p style="color: #ffa800; font-size: var(--vk-fs-xs); margin-top: 5px">
                {{ $lang.common_txt347 }}
              </p>
              <p class="f-w">{{ formatMetric(InitDate2.newRechargeAmount) }}</p>
            </div>
            <div
              class="t-c"
              style="position: absolute; right: 10px; top: 318px"
            >
              <p style="color: #ffa800; font-size: var(--vk-fs-xs)">
                {{ $lang.common_txt348 }}
              </p>
              <p class="f-w">{{ rebateRateText }}</p>
              <p style="color: #ffa800; font-size: var(--vk-fs-xs); margin-top: 5px">
                {{ $lang.common_txt349 }}
              </p>
              <p class="f-w">{{ formatMetric(InitDate2.betEffc) }}</p>
              <p style="color: #ffa800; font-size: var(--vk-fs-xs); margin-top: 5px">
                {{ $lang.common_txt350 }}
              </p>
              <p class="f-w">{{ formatMetric(InitDate2.newRechargeCount) }}</p>
            </div>
            <div
              style="position: absolute; bottom: 20px; left: 10px"
              v-html="$lang.common_txt351"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Init, GetTeamTotalReports, VipInit } from '@/api/common'
import { contentOf, failMessage, handleNeedLogin, isOk, toArray, toNumber } from './safeFlow'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { copyTextToClipboard } from '@/components/share/shareSafety'
import { hasUnavailableMarker } from '@/views/details/activity/rewardApi'

function browserLocalStorage() {
  try {
    return typeof safeLocalStorage === 'function' ? safeLocalStorage() : null
  } catch (e) {
    return null
  }
}

function allianceFailureMessage(error, fallback) {
  const message = failMessage(error, fallback)
  return /^network error$/i.test(String(message || '').trim()) ? fallback : message
}

function fallbackToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function hasReadFallbackMarker(payload, depth = 0, seen = []) {
  if (!payload || typeof payload !== 'object' || depth > 6 || seen.includes(payload)) return false
  seen.push(payload)
  if (Array.isArray(payload)) return payload.some(item => hasReadFallbackMarker(item, depth + 1, seen))
  return Object.keys(payload).some(key => {
    const value = payload[key]
    const keyToken = fallbackToken(key)
    const valueToken = fallbackToken(value)
    if (keyToken.includes('fallback') && (value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(valueToken) || valueToken.includes('fallback'))) return true
    if (value && typeof value === 'object') return hasReadFallbackMarker(value, depth + 1, seen)
    return valueToken.includes('fallback')
  })
}

function isReadOk(res) {
  return isOk(res) && !hasReadFallbackMarker(res)
}

function isReadUnavailable(res) {
  const payload = res && res.response && res.response.data ? res.response.data : res
  return hasUnavailableMarker(payload)
}

function defaultTeamReport() {
  return {
    totalUserCount: 0,
    totalRechargeAmount: 0,
    newRechargeAmount: 0,
    newRechargeCount: 0,
    totalRechargeCount: 0,
    betEffc: 0,
    betEffcCount: 0
  }
}

export default {
  name: 'Alliance',
  components: {},
  data() {
    return {
      inviteCode: '',
      vipLevel: 0,
      vipList: [],
      currentVip: {},
      nextVip: {},
      vipProgress: {},
      InitDate: {},
      InitDate2: defaultTeamReport(),
      isExpanded: false,
      inviteReadError: '',
      teamReadError: '',
      vipReadError: '',
      isInviteShareReady: false
    }
  },
  computed: {
    currentVipLevel() {
      return toNumber(this.firstMetric(this.currentVip, ['vipLevel', 'vip_level', 'level'], this.vipLevel))
    },
    nextVipLevel() {
      return toNumber(this.firstMetric(this.nextVip, ['vipLevel', 'vip_level', 'level'], this.currentVipLevel))
    },
    commissionRateText() {
      return this.percentText(this.firstMetric(this.currentVip, [
        'commissionRate',
        'commission_rate',
        'teamCommissionRate',
        'team_commission_rate',
        'monthlyBonusRate',
        'monthly_bonus_rate'
      ], 0))
    },
    rebateRateText() {
      return this.percentText(this.firstMetric(this.currentVip, [
        'rebateRate',
        'rebate_rate',
        'cashbackRate',
        'cashback_rate',
        'signBalLimit',
        'sign_bal_limit'
      ], 0))
    },
    allianceDisplay() {
      return {
        vipLevel: this.currentVipLevel,
        nextVipLevel: this.nextVipLevel,
        progress: this.firstMetric(this.vipProgress, ['progress', 'value', 'percent'], this.vipProgress)
      }
    }
  },
  mounted() {
    if (this.token) {
      this.Init()
      this.GetTeamTotalReports()
      this.VipInit()
    }
  },
  methods: {
    getImgCon() {
      const level = this.currentVipLevel
      if (level === 0) {
        return require(`@/assets/img/vip/0_bg.png`)
      } else if ([1, 2, 3, 4, 5].includes(level)) {
        return require(`@/assets/img/vip/1_5_bg.png`)
      } else if ([6, 7, 8, 9, 10].includes(level)) {
        return require(`@/assets/img/vip/6_10_bg.png`)
      } else if ([11, 12, 13, 14, 15].includes(level)) {
        return require(`@/assets/img/vip/11_15_bg.png`)
      } else if ([16, 17, 18, 19, 20].includes(level)) {
        return require(`@/assets/img/vip/16_20_bg.png`)
      } else if ([21, 22, 23, 24, 25].includes(level)) {
        return require(`@/assets/img/vip/21_25_bg.png`)
      } else if ([26, 27, 28, 29, 30].includes(level)) {
        return require(`@/assets/img/vip/26_30_bg.png`)
      }
      return require(`@/assets/img/vip/0_bg.png`)
    },
    firstMetric(source, keys, fallback = 0) {
      const row = source && typeof source === 'object' ? source : {}
      for (const key of keys) {
        const value = row[key]
        if (value !== undefined && value !== null && value !== '') return value
      }
      return fallback
    },
    firstList(source, keys) {
      const row = source && typeof source === 'object' ? source : {}
      for (const key of keys) {
        const value = row[key]
        if (Array.isArray(value)) return value
      }
      return []
    },
    normalizeVipRow(row = {}) {
      if (!row || typeof row !== 'object' || !Object.keys(row).length) return {}
      return {
        ...row,
        vipLevel: toNumber(this.firstMetric(row, ['vipLevel', 'vip_level', 'level'], 0)),
        monthlyBonus: this.firstMetric(row, ['monthlyBonus', 'monthly_bonus', 'monthBonus', 'month_bonus', 'commissionRate', 'commission_rate'], 0),
        rechargeAmount: this.firstMetric(row, ['rechargeAmount', 'recharge_amount', 'amount', 'minRechargeAmount', 'min_recharge_amount'], 0)
      }
    },
    normalizeTeamReport(content = {}) {
      return {
        totalUserCount: toNumber(this.firstMetric(content, ['totalUserCount', 'total_user_count', 'userCount', 'user_count', 'teamUserCount', 'team_user_count', 'memberCount', 'member_count', 'total'], 0)),
        totalRechargeAmount: toNumber(this.firstMetric(content, ['totalRechargeAmount', 'total_recharge_amount', 'rechargeTotalAmount', 'recharge_total_amount', 'rechargeAmount', 'recharge_amount'], 0)),
        newRechargeAmount: toNumber(this.firstMetric(content, ['newRechargeAmount', 'new_recharge_amount', 'todayRechargeAmount', 'today_recharge_amount', 'firstRechargeAmount', 'first_recharge_amount'], 0)),
        newRechargeCount: toNumber(this.firstMetric(content, ['newRechargeCount', 'new_recharge_count', 'todayRechargeCount', 'today_recharge_count', 'rechargeUserCount', 'recharge_user_count'], 0)),
        totalRechargeCount: toNumber(this.firstMetric(content, ['totalRechargeCount', 'total_recharge_count', 'rechargeTotalCount', 'recharge_total_count', 'rechargeCount', 'recharge_count'], 0)),
        betEffc: toNumber(this.firstMetric(content, ['betEffc', 'bet_effc', 'effectiveBetAmount', 'effective_bet_amount', 'betAmount', 'bet_amount'], 0)),
        betEffcCount: toNumber(this.firstMetric(content, ['betEffcCount', 'bet_effc_count', 'effectiveBetUserCount', 'effective_bet_user_count', 'betCount', 'bet_count'], 0))
      }
    },
    formatMetric(value) {
      const number = toNumber(value)
      if (typeof this.$formatNumberWithCommas === 'function') return this.$formatNumberWithCommas(number)
      return number
    },
    safeToast(payload) {
      if (typeof this.$toast === 'function') {
        this.$toast(payload)
      }
    },
    inviteShareOrigin() {
      try {
        const location = typeof window !== 'undefined' && window ? window.location : null
        return location && location.origin ? location.origin : ''
      } catch (e) {
        return ''
      }
    },
    percentText(value) {
      if (value === undefined || value === null || value === '') return '0%'
      const number = Number(value)
      if (!Number.isFinite(number)) return String(value)
      const percent = Math.abs(number) > 0 && Math.abs(number) <= 1 ? number * 100 : number
      return `${Number(percent.toFixed(2)).toString()}%`
    },
    copyText() {
      if (!this.isInviteShareReady) {
        if (typeof this.$toast === 'function') {
          this.$toast({ message: this.inviteReadError || this.$lang.noempt || 'No data', icon: 'cross' })
        }
        return
      }
      if (!this.inviteCode) {
        if (typeof this.$toast === 'function') {
          this.$toast({ message: this.$lang.noempt || 'No data', icon: 'cross' })
        }
        return
      }
      let copied = false
      try {
        copied = copyTextToClipboard(this.inviteCode)
      } catch (e) {
        copied = false
      }
      if (typeof this.$toast === 'function') {
        this.$toast({
          message: copied ? (this.$lang.Sucesso || 'Success') : (this.$lang.copy_failed || 'Copy failed'),
          icon: copied ? 'success' : 'cross'
        })
      }
    },
    resetTeamReportState() {
      this.InitDate2 = defaultTeamReport()
    },
    resetInviteReadState() {
      this.InitDate = {}
      this.vipLevel = 0
      this.inviteCode = ''
      this.isInviteShareReady = false
    },
    blockInviteRead(message, res) {
      this.inviteReadError = message
      this.resetInviteReadState()
      if (!isReadUnavailable(res)) this.safeToast({ message: this.inviteReadError, icon: 'cross' })
    },
    async VipInit() {
      try {
        const data = await VipInit()
        if (handleNeedLogin(this, data, this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now', { isValue: 'isLogin' }, { replace: true })) return
        if (isReadOk(data)) {
          this.vipReadError = ''
          const content = contentOf(data)
          this.vipList = toArray(this.firstList(content, ['vipList', 'vip_list', 'list', 'records', 'dataList', 'data_list', 'items'])).map(this.normalizeVipRow)
          this.currentVip = this.normalizeVipRow(content.currentVip || content.current_vip || {})
          this.nextVip = this.normalizeVipRow(content.nextVip || content.next_vip || {})
          this.vipProgress = content.progress || content.vipProgress || content.vip_progress || {}
          if (!Object.keys(this.currentVip).length && this.vipList.length) {
            this.currentVip = this.vipList.find(item => toNumber(item.vipLevel) === this.vipLevel) || this.vipList[0]
          }
          if (!Object.keys(this.nextVip).length) this.nextVip = this.currentVip
        } else {
          this.vipReadError = failMessage(data, this.$lang.feature_unavailable || 'Data is temporarily unavailable. Please try again later.')
          if (!isReadUnavailable(data)) this.safeToast({ message: this.vipReadError, icon: 'cross' })
        }
      } catch (e) {
        this.vipReadError = allianceFailureMessage(e, this.$lang.feature_unavailable || 'Data is temporarily unavailable. Please try again later.')
        if (!isReadUnavailable(e)) this.safeToast({ message: this.vipReadError, icon: 'cross' })
      }
    },
    async GetTeamTotalReports() {
      try {
        const data = await GetTeamTotalReports()
        if (handleNeedLogin(this, data, this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now', { isValue: 'isLogin' }, { replace: true })) return
        if (isReadOk(data)) {
          this.teamReadError = ''
          this.InitDate2 = this.normalizeTeamReport(contentOf(data))
        } else {
          this.teamReadError = failMessage(data, this.$lang.feature_unavailable || 'Data is temporarily unavailable. Please try again later.')
          if (!isReadUnavailable(data)) this.safeToast({ message: this.teamReadError, icon: 'cross' })
        }
      } catch (e) {
        this.teamReadError = allianceFailureMessage(e, this.$lang.feature_unavailable || 'Data is temporarily unavailable. Please try again later.')
        if (!isReadUnavailable(e)) this.safeToast({ message: this.teamReadError, icon: 'cross' })
      }
    },
    async Init() {
      try {
        const data = await Init()
        this.isInviteShareReady = false
        if (handleNeedLogin(this, data, this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now', { isValue: 'isLogin' }, { replace: true })) {
          this.inviteReadError = failMessage(data, 'Please log in to continue')
          this.resetInviteReadState()
          return
        }
        if (isReadOk(data)) {
          this.inviteReadError = ''
          const content = contentOf(data)
          this.InitDate = content
          this.vipLevel = toNumber(this.firstMetric(content, ['vipLevel', 'vip_level', 'level'], 0))
          const inviteCode = this.firstMetric(content, ['inviteCode', 'invite_code', 'code', 'invitationCode', 'invitation_code'], '')
          this.inviteCode = inviteCode
            ? `${this.inviteShareOrigin()}/${safeGetStorageItem(browserLocalStorage(), 'country')}/home?id=${inviteCode}`
            : ''
          this.isInviteShareReady = Boolean(this.inviteCode)
        } else {
          this.blockInviteRead(failMessage(data, this.$lang.feature_unavailable || 'Data is temporarily unavailable. Please try again later.'), data)
        }
      } catch (e) {
        this.blockInviteRead(allianceFailureMessage(e, this.$lang.feature_unavailable || 'Data is temporarily unavailable. Please try again later.'), e)
      }
    },
    goLeft() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.alliance-diagnostic {
  margin-bottom: 8px;
  padding: 10px 12px;
  border: 1px solid rgba(245, 158, 11, 0.35);
  border-radius: 8px;
  background: rgba(245, 158, 11, 0.12);
  color: #fef3c7;
  font-size: var(--vk-fs-xs);
  line-height: 18px;
}

.share-target-disabled,
.copy-btn-disabled {
  opacity: 0.45;
  filter: grayscale(100%);
}

.copy-btn-disabled {
  cursor: not-allowed;
}

.newAlliance_display {
  margin-top: 10px;
  background: url(../../../assets/img/otgame/Alliance_9.png) no-repeat;
  height: 560px;
  background-size: 100% 100%;
}
.newAlliance_share {
  margin-top: 10px;
  background: url(../../../assets/img/otgame/Alliance_8.png) no-repeat;
  height: 161px;
  background-size: 100% 100%;
}
.newAlliance {
  background: url(../../../assets/img/otgame/Alliance_bj.jpg) no-repeat;
  min-height: 180vh;
  background-size: 100% 100%;
}
.newAlliance_information {
  background: url(../../../assets/img/otgame/Alliance_1.png) no-repeat;
  height: 150px;
  background-size: 100% 100%;
}
.newAlliance_card {
  background: url(../../../assets/img/otgame/Alliance_2.png) no-repeat;
  height: 162px;
  background-size: 100% 100%;
}
.card_desc {
  background: #2a5e1c;
  height: 25px;
  margin-top: -2px;
  border-radius: 0 0 8px 8px;
  color: #dfe3df;
  cursor: pointer;
}
.expanded-content {
  background: #2a5e1c;
  color: #fff;
  padding: 0 10px 10px 10px;
  margin-top: -2px;

  // 新的佣金列表样式（替代表格）
  .commission-container {
    width: 100%;

    .commission-header,
    .commission-row {
      display: flex;
      width: 100%;
    }

    .commission-col {
      flex: 1;
      text-align: center;
      margin: 0;
      padding: 10px 0;
    }

    // .commission-header {
    //   border-bottom: 1px solid #4a7e3c;
    // }

    // 隔行背景色
    .odd-row {
      background-color: #1b3d14;
    }

    // 当前VIP项黄色边框
    .current-vip {
      border: 2px solid #ffdc4f;
      border-radius: 10px !important;
    }

    .commission-row .commission-col {
      padding: 1px 0;
    }
  }
}
.newAlliance_card_txt {
  background: linear-gradient(180deg, #fcffb3, #fffc00);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-style: italic;
  font-weight: bold;
  font-size: var(--vk-fs-base);
}
.newAlliance_card_txt2 {
  color: #fcff00;
  font-weight: 700;
  text-shadow: -1px -1px 0 #064b10, 1px -1px 0 #064b10, -1px 1px 0 #064b10,
    1px 1px 0 #064b10, -1px 0 0 #064b10, 1px 0 0 #064b10, 0 -1px 0 #064b10,
    0 1px 0 #064b10;
}
.card_right_amount {
  font-size: 28px;
  color: #ffffff;
  font-weight: 800;
  text-shadow: -2px -2px 0 #064b10, 2px -2px 0 #064b10, -2px 2px 0 #064b10,
    2px 2px 0 #064b10, -2px 0 0 #064b10, 2px 0 0 #064b10, 0 -2px 0 #064b10,
    0 2px 0 #064b10;
}
.card_right_btn {
  background: url(../../../assets/img/otgame/Alliance_7.png) no-repeat;
  background-size: 100% 100%;
  height: 42px;
  filter: grayscale(100%);
  max-width: 145px;
  padding-top: 9px;
  font-size: var(--vk-fs-15);
  font-weight: bold;
  margin-left: 35px;
}
</style>
